import { INTENT, STATE, dispatch, on } from "./ui-events.js";

const SELECTORS = {
  trigger: "[data-bm-trigger]",
};

class BurgerMenu extends HTMLElement {
  #callbackFunctions = [];

  connectedCallback() {
    try {
      this.init();
    } catch (error) {
      console.error("[BurgerMenu:init]", error);
    }
  }

  init() {
    this.#bindElements();
    this.#bindEvents();
  }

  #bindElements() {
    this.trigger = this.querySelector(SELECTORS.trigger);
  }

  #bindEvents() {
    this.trigger?.addEventListener("click", this.#onTriggerClick.bind(this));
    this.#callbackFunctions.push(
      on(STATE.NAV_CLOSED, () => this.#setOpen(false)),
    );
  }

  #onTriggerClick() {
    if ("vibrate" in navigator) navigator.vibrate(10);
    if (this.classList.contains("is-open")) {
      dispatch(INTENT.NAV_CLOSE);
    } else {
      this.#setOpen(true);
      dispatch(INTENT.NAV_OPEN);
    }
  }

  #setOpen(value) {
    this.classList.toggle("is-open", value);
    this.trigger?.setAttribute("aria-expanded", String(value));
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #cleanup() {
    this.#callbackFunctions.forEach((fn) => fn());
    this.#callbackFunctions = [];
  }
}

if (!customElements.get("burger-menu")) {
  customElements.define("burger-menu", BurgerMenu);
}
